import { DEFAULT_POLICY_MAPPER } from 'components/landing/constants';
import { usePageInfo } from 'context/PageInfoContext';

export default function defaultPolicy (culture = 'es-ar') {
    const { pageInfo } = usePageInfo();
    const familyCodes = pageInfo.page_context.page_dinamic_data.family_codes;
    if (familyCodes !== undefined && familyCodes.length > 0) {
        return pageInfo.page_context.page_dinamic_data.family_codes[2];
    }
    return DEFAULT_POLICY_MAPPER[culture];
}
